export const utmKeys: Record<string, string> = {
        u_id: 'utm_id',
        u_src: 'utm_source',
        u_mdm: 'utm_medium',
        u_trm: 'utm_term',
        u_cmp: 'utm_campaign',
        u_cnt: 'utm_content'
}

const defaultSesUtmValues: Record<string, string> = {
        utm_source: 'ielts_ses',
        utm_medium: 'referral',
        utm_campaign: 'ses',
        utm_content: ''
    }

const generateSesUtmParams = (url: string, service: string): string => {
    const urlObj = new URL(url)
    const params = urlObj.searchParams

    Object.keys(defaultSesUtmValues).forEach(key => {
        const value = params.get(key)
        if (key === 'utm_content') {
            params.set(key, service)
        } else if (!value || value === '' || value === "''") {
            params.set(key, defaultSesUtmValues[key])
        }
    })
    const baseUrl = url.split('?')[0].replace(/\/$/, '')
    const queryString = params.toString()
    return queryString ? `${baseUrl}?${queryString}` : baseUrl
}

export const generateUtmUrl = (url: string, code?: any): string => {
    if (!sessionStorage.getItem('utm_value')) {
        setUtminSession()
    }
    const url_List: { [key: string]: string } = {
        cxUrl: 'https://ielts.idp.com',
        orsUrl: 'https://ielts.idp.com/book',
        cxPreparationUrl: 'https://ielts.idp.com/prepare/ielts-test-preparation-practice-tests-material',
        cxBandscoreUrl: 'https://ielts.idp.com/results/how-ielts-is-marked/band-score-calculator',
        cxSystemRequirements: 'https://ielts.idp.com/lp/ielts-online-system-requirements',
        bxSearchWizardUrl: 'https://bxsearch.ielts.idp.com/wizard',
        legalNoticeURLPrivacy: 'https://ielts.idp.com/legal-notices#ielts-online-privacy-notice',
        legalNoticeAusUrl: 'https://ielts.idp.com/legal-notices#ielts-australia-privacy-policy',
        legalNoticeTnc: 'https://ielts.idp.com/legal-notices#ielts-test-and-payment-terms-and-conditions',
        legalNotice: 'https://ielts.idp.com/legal-notices',
        bxInstructionURL: `https://ielts.idp.com/test-centres/${code}/offline-payment-instructions`,
        bxBookingSummary: 'https://book.ielts.idp.com/account/booking-summary'
    }
    const utm_value = sessionStorage.getItem('utm_value')
    let baseUrl = ''
    if (typeof url === 'string' && url.includes('://')) {
        baseUrl = url
    } else if (url_List[url]) {
        baseUrl = url_List[url]
    } else {
        baseUrl = ''
    }
    const appendQueryParams = (url: string, params: string): string => {
        if (url.includes('?')) {
            return url + '&' + params
        } else {
            return url + '?' + params
        }
    }
    let queryParams = ''
    if (utm_value && typeof utm_value === 'string') {
        const sanitizedUtmValue = utm_value.replace(/[<>{}]/g, '')
        const constructUtm = sanitizedUtmValue.replace(/&u_[^=]+=[^&]*/g, match => {
        const [key, value] = match.slice(1).split('=')
        const utm_fullKey = utmKeys[key] || key
        return value ? `&${utm_fullKey}=${value}` : ''
    })
     queryParams += `&${constructUtm.substring(1)}`
    }
    const itmParams = localStorage.getItem('itmParams')
    if (itmParams) {
        queryParams += itmParams
    }
    if (queryParams) {
        baseUrl = appendQueryParams(baseUrl, queryParams.substring(1))
    }
    return baseUrl
}

export { generateSesUtmParams }

export const formUtmparams = (urlParams: URLSearchParams, encode_utm_value: string, utm_value: string) => {
    const utm_paranm = decodeURIComponent(urlParams.get(encode_utm_value) || decodeURIComponent(urlParams.get(utm_value) ?? ''))
    return (utm_paranm && utm_paranm != 'null') ? '&' + encode_utm_value + '=' + utm_paranm : ''
}
export const setUtminSession = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const utm_url = formUtmparams(urlParams, 'u_id', 'utm_id') +
        formUtmparams(urlParams, 'u_src', 'utm_source') +
        formUtmparams(urlParams, 'u_mdm', 'utm_medium') +
        formUtmparams(urlParams, 'u_trm', 'utm_term') +
        formUtmparams(urlParams, 'u_cmp', 'utm_campaign') +
        formUtmparams(urlParams, 'u_cnt', 'utm_content')
    if (!sessionStorage.getItem('referrerUrl')) {
        sessionStorage.setItem('referrerUrl', (urlParams.get('referrerUrl') || document.referrer || document.location.origin))
    }
    if (utm_url) {
        sessionStorage.setItem('utm_value', utm_url)
    }
}

export const setItmParamsInStorage = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const itm_source = urlParams.get('itm_source') || ''
    const itm_medium = urlParams.get('itm_medium') || ''
    const itm_campaign = urlParams.get('itm_campaign') || ''
    const itm_content = urlParams.get('itm_content') || ''
    if (itm_source || itm_medium || itm_campaign || itm_content) {
        let itmValue = ''
        if (itm_source) itmValue += `&itm_source=${itm_source}`
        if (itm_medium) itmValue += `&itm_medium=${itm_medium}`
        if (itm_campaign) itmValue += `&itm_campaign=${itm_campaign}`
        if (itm_content) itmValue += `&itm_content=${itm_content}`
        localStorage.setItem('itmParams', itmValue)
    }
}

export const getItmParamsFromStorage = (): { itm_source: string, itm_medium: string, itm_campaign: string, itm_content: string } | null => {
    const stored = localStorage.getItem('itmParams')
    if (stored) {
        const params = new URLSearchParams(stored)
        const itm_source = params.get('itm_source') || ''
        const itm_medium = params.get('itm_medium') || ''
        const itm_campaign = params.get('itm_campaign') || ''
        const itm_content = params.get('itm_content') || ''
        if (itm_source || itm_medium || itm_campaign || itm_content) {
            return { itm_source, itm_medium, itm_campaign, itm_content }
        }
    }
    return null
}
